module.exports = __webpack_public_path__ + "img/creditu-icons.43c5fcbd.svg";